import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TimelineActions } from "../../_actions";
import { useForm, Controller } from "react-hook-form";
import { useEventListener } from "../../_hooks";
import {
  Button,
  Icon,
  PaneLoader,
  SubGroupPicker,
  Toggle,
  FormError,
} from "../../_components";
import { useModal } from "../../_contexts";
import { ErrorMessage } from "@hookform/error-message";
import ReactTooltip from "react-tooltip";

const MAXTIMELINES = 4;

export function NewTimelineForm(props) {
  const { chronicleID, worldID, item, prevModal } = props;
  const { items: timelines } = useSelector((state) => state.timelines);
  const { closeModal, openModal } = useModal();
  const [isLoading, setLoading] = useState(false);
  // console.log('Existing Timeline', item);

  const dispatch = useDispatch();

  const { handleSubmit, errors, control, watch, formState } = useForm({
    mode: "all",
    defaultValues: {
      title: item?.title || "",
      description: item?.description || "",
      private: item?.private || false,
      subGroups: item?.subGroups || [],
      active: item?.active || true,
    },
    shouldUnregister: false,
  });

  const onSubmit = (formData) => {
    setLoading(true);
    // console.log('New Timeline', formData);
    if (item) {
      const newTimeline = { ...item };
      Object.assign(newTimeline, formData);

      dispatch(TimelineActions.updateTimeline(newTimeline));
      setLoading(false);
      if (prevModal && prevModal.length > 0) {
        openModal(prevModal);
      } else {
        closeModal();
      }
    } else {
      const newTimeline = { ...formData };
      const activeTimelines = timelines.filter((t) => t.active === true);
      newTimeline.order = timelines ? timelines.length : 99999;
      if (
        (timelines && timelines.length === 0) ||
        activeTimelines.length < MAXTIMELINES
      ) {
        newTimeline.active = true;
      }
      dispatch(
        TimelineActions.newTimeline({
          chronicleID,
          worldID,
          timeline: newTimeline,
        })
      );
      setLoading(false);
      if (prevModal && prevModal.length > 0) {
        openModal(prevModal);
      } else {
        closeModal();
      }
    }
  };

  const handleCancel = (ev) => {
    setLoading(false);
    if (prevModal && prevModal.length > 0) {
      openModal(prevModal);
    } else {
      closeModal();
    }
  };

  const { isValidating, isSubmitting, dirtyFields, touched } = formState;

  const handleKeyClose = (ev) => {
    // console.log("Key up: ", ev);
    if (ev.key && ev.key.toLowerCase() === "escape") {
      console.log("Form State: ", { ...formState });
      if (!isValidating && !isSubmitting) {
        if (
          // formState.dirtyFields &&
          Object.keys(dirtyFields).length === 0 &&
          // formState.touched &&
          Object.keys(touched).length === 0
        ) {
          // console.log("dirty fields!");
          handleCancel();
        }
      }
    }
  };

  useEventListener("keyup", handleKeyClose);

  const tooltipID = "chronosTimelineForm";
  const tooltipIcon = "fas fa-info-circle";

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="chronos-form">
      <div className="form-group">
        <label htmlFor="title" className="chronos-form-title">
          Title
        </label>
        <Controller
          as="input"
          id="title"
          name="title"
          control={control}
          className="form-control"
          rules={{
            required: {
              value: true,
              message: "You must specify a name for this Timeline.",
            },
          }}
        />
        <ErrorMessage
          errors={errors}
          name="title"
          render={({ message }) => <FormError message={message} />}
        />
      </div>
      <div className="form-group">
        <label className="chronos-form-title" htmlFor="private">
          Privacy&nbsp;
          <Icon
            icon={tooltipIcon}
            data-tip="Set this Timeline to public, or restrict access to Subscriber Groups."
            data-for={tooltipID}
          />
        </label>
        <br />
        <Controller
          control={control}
          name="private"
          render={({ onChange, value }) => (
            <Toggle
              id="private"
              onChange={onChange}
              checked={value}
              onText="Private"
              offText="Public"
              onColor="#bfb49d"
              offColor="#766c57"
            />
          )}
        />
      </div>
      {watch("private") === true && (
        <div className="form-group">
          <label htmlFor="subGroups" className="chronos-form-title">
            Subscriber Groups Access &nbsp;
            <Icon
              icon={tooltipIcon}
              data-tip="Select the Subscriber Groups you want to grant access to. The allowed groups will appear in the right column."
              data-for={tooltipID}
            />
          </label>
          <Controller
            control={control}
            name="subGroups"
            render={({ onChange, value }) => (
              <SubGroupPicker value={value} onChange={onChange} />
            )}
          />
        </div>
      )}

      <div className="form-controls">
        {/* <Button type="button" color="secondary" onClick={handleCancel}>
          <Icon icon="far fa-ban fa-fw" />
          Cancel
        </Button> */}
        &nbsp;
        {item && item._id && (
          <Button color="primary" type="submit">
            <Icon icon="fas fa-save fa-fw" />
            &nbsp;Save
          </Button>
        )}
        {!item && (
          <Button color="primary" type="submit">
            <Icon icon="fas fa-plus fa-fw" />
            &nbsp;Create
          </Button>
        )}
      </div>
      <ReactTooltip effect="solid" id={tooltipID} />
      <PaneLoader
        text="Timeline"
        isNew={!(item && item._id)}
        isLoading={isLoading}
      />
    </form>
  );
}
